package settings.syndrome.components


import antd.form.form
import antd.form.formItem
import antd.input.input
import antd.input.textArea
import antd.message.message
import antd.modal.modal
import antd.radio.radioButton
import antd.radio.radioGroup
import antd.select.SelectComponent
import antd.select.optGroup
import antd.select.option
import antd.select.select
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.orm.mapping.SyndromeIndicationSignSymptom
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationSignSymptomRule
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationSignSymptomStatus
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationSignSymptomType
import external.select.filterOptionFun
import kotlinext.js.Object
import react.*
import react.dom.div
import react.dom.span

external interface SyndromeIndicationSignSymptomEditModalProps : RProps {
    var isVisible:Boolean
    var changeVisibility:(Boolean)->Unit
    var symptomOptions: Array<CascadedOption<String>>
    var syndromeIndicationSignSymptom: SyndromeIndicationSignSymptom
    var save:(syndromeIndicationSignSymptom: SyndromeIndicationSignSymptom, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<SyndromeIndicationSignSymptom>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
    var onSaved:()->Unit
}

data class SyndromeIndicationSignSymptomEditModalContextData(var placeHolderFunction: (param: String) -> Unit)

val SyndromeIndicationSignSymptomEditModal = functionalComponent<SyndromeIndicationSignSymptomEditModalProps> { props ->

    val (editingSyndromeIndicationSignSymptom,setEditingSyndromeIndicationSignSymptom) = useState(props.syndromeIndicationSignSymptom)
    val (statusMessage,setStatusMessage) = useState("")

    useEffectOnce { }

    useEffect(props.syndromeIndicationSignSymptom){
        setEditingSyndromeIndicationSignSymptom(props.syndromeIndicationSignSymptom)
    }

    div("SyndromeIndicationSignSymptomEditModal") {
        modal {
            attrs {
                title = if(editingSyndromeIndicationSignSymptom.id.isNullOrBlank()) "添加症状" else "编辑症状"
                visible = props.isVisible
                onCancel = {
                    props.changeVisibility(false)
                }
                onOk = {
                    setStatusMessage("正在保存中...")
                    props.save(editingSyndromeIndicationSignSymptom,{resp->
                        if(resp.ok()){
                            setStatusMessage("保存成功!")
                            props.changeVisibility(false)
                            props.onSaved()
                        }else{
                            setStatusMessage("出错了，${resp.message?:"未知错误"}")
                            //message.error("出错了，${resp.message?:"未知错误"}")
                        }
                    },{
                        //console.log(it)
                        setStatusMessage("出错了，${it.message?:"未知错误"}")
                        //message.error("出错了，${it.message?:"未知错误"}")
                    })
                }
            }
            form {
                attrs{
                    layout = "horizontal"
                }
                if(!editingSyndromeIndicationSignSymptom.id.isNullOrBlank()){
                    formItem {
                        attrs {
                            label = "ID"
                        }
                        span{
                            +editingSyndromeIndicationSignSymptom.id!!
                        }
                    }
                }
                formItem{
                    attrs{
                        label = "症状类型"
                    }
                   /* if(editingSyndromeIndicationSignSymptom.parentId.isNullOrBlank()) {*/
                        radioGroup {
                            attrs {
                                value = editingSyndromeIndicationSignSymptom.type
                                onChange = { event ->
                                    val symptom = Object.assign(
                                        SyndromeIndicationSignSymptom(),
                                        editingSyndromeIndicationSignSymptom
                                    )
                                    symptom.type = event.target.value
                                    setEditingSyndromeIndicationSignSymptom(symptom)
                                }
                            }
                            SyndromeIndicationSignSymptomType.values().forEach { type ->
                                radioButton {
                                    attrs {
                                        value = type
                                    }
                                    +"${type.getLiteral()}"
                                }
                            }
                        }
                    /*}else{
                        span{
                            +"${editingSyndromeIndicationSignSymptom.type?.getLiteral()?:""}"
                        }
                    }*/
                }
                if(SyndromeIndicationSignSymptomType.组合 == editingSyndromeIndicationSignSymptom.type){
                    formItem {
                        attrs{
                            label = "组合名称"
                        }
                        input {
                            attrs {
                                value = editingSyndromeIndicationSignSymptom.groupName?:""
                                placeholder = "请填写组合名称"
                                onChange = {event: dynamic ->
                                    val symptom = Object.assign(SyndromeIndicationSignSymptom(),editingSyndromeIndicationSignSymptom)
                                    symptom.groupName = event.target.value as String
                                    setEditingSyndromeIndicationSignSymptom(symptom)
                                }
                            }
                        }
                    }
                }else{
                    formItem {
                        attrs{
                            label = "症状名称"
                        }
                        select<String, SelectComponent<String>> {
                            attrs {
                                showSearch = true
                                style = kotlinext.js.js { width = 200 }
                                value = editingSyndromeIndicationSignSymptom.symptomId
                                labelInValue = false
                                placeholder = "选择症状"
                                optionLabelProp = "label"
                                filterOption = ::filterOptionFun
                                onChange = { value: String, option: dynamic ->
                                    console.log("option",option)
                                    val symptom = Object.assign(SyndromeIndicationSignSymptom(),editingSyndromeIndicationSignSymptom)
                                    symptom.symptomId = value
                                    //symptom.name = option.label
                                    setEditingSyndromeIndicationSignSymptom(symptom)
                                }
                            }
                            props.symptomOptions.forEach { optGroup ->
                                optGroup {
                                    attrs{
                                        label = "${optGroup.label}"
                                    }
                                    optGroup.children?.forEach { opt->
                                        option {
                                            attrs{
                                                label = "${opt.label}"
                                                value = "${opt.value}"
                                            }
                                            +"${opt.label}"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                formItem{
                    attrs{
                        label = "应用规则"
                    }
                    radioGroup {
                        attrs{
                            value = editingSyndromeIndicationSignSymptom.rule
                            onChange = { event->
                                val symptom = Object.assign(SyndromeIndicationSignSymptom(),editingSyndromeIndicationSignSymptom)
                                symptom.rule = event.target.value
                                setEditingSyndromeIndicationSignSymptom(symptom)
                            }
                        }
                        SyndromeIndicationSignSymptomRule.values().forEach { type ->
                            radioButton {
                                attrs{
                                    value = type
                                }
                                +"${type.getLiteral()}"
                            }
                        }
                    }
                }
                if(SyndromeIndicationSignSymptomRule.可见 == editingSyndromeIndicationSignSymptom.rule){
                    formItem{
                        attrs{
                            label = "诊断价值"
                        }
                        select<String, SelectComponent<String>> {
                            attrs {
                                mode = "default"
                                labelInValue = false
                                value = "${editingSyndromeIndicationSignSymptom.score?:""}"
                                placeholder = "诊断价值"
                                optionLabelProp = "label"
                                filterOption = ::filterOptionFun
                                //onSearch = fetchUser
                                onChange = { selected: String, any: Any ->
                                    val entity = Object.assign(SyndromeIndicationSignSymptom(),editingSyndromeIndicationSignSymptom)
                                    entity.score = selected.toInt()
                                    setEditingSyndromeIndicationSignSymptom(entity)
                                }
                                style = kotlinext.js.js { width = "100%" }
                            }
                            IntRange(1,5).forEach { opt ->
                                option {
                                    attrs{
                                        label = "${opt}分"
                                        value = "${opt}"
                                    }
                                    +"${opt}"
                                }
                            }
                        }
                    }
                }

                formItem {
                    attrs{
                        label = "症状描述"
                    }
                    textArea {
                        attrs {
                            value = editingSyndromeIndicationSignSymptom.description ?:""
                            rows = 3
                            onChange = {event: dynamic ->
                                val symptom = Object.assign(SyndromeIndicationSignSymptom(),editingSyndromeIndicationSignSymptom)
                                symptom.description = event.target.value as String
                                setEditingSyndromeIndicationSignSymptom(symptom)
                            }
                        }
                    }
                }

                formItem {
                    attrs{
                        label = "症状出处"
                    }
                    input {
                        attrs {
                            value = editingSyndromeIndicationSignSymptom.source?:""
                            placeholder = "请填写出处"
                            onChange = {event: dynamic ->
                                val symptom = Object.assign(SyndromeIndicationSignSymptom(),editingSyndromeIndicationSignSymptom)
                                symptom.source = event.target.value
                                setEditingSyndromeIndicationSignSymptom(symptom)
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "症状排序"
                    }

                    select<String, SelectComponent<String>> {
                        attrs {
                            mode = "default"
                            labelInValue = false
                            value = "${editingSyndromeIndicationSignSymptom.weight ?: ""}"
                            placeholder = "排序位置"
                            optionLabelProp = "label"
                            filterOption = ::filterOptionFun
                            //onSearch = fetchUser
                            onChange = { selected: String, any: Any ->
                                val entity =
                                    Object.assign(SyndromeIndicationSignSymptom(), editingSyndromeIndicationSignSymptom)
                                entity.weight = selected.toInt()
                                setEditingSyndromeIndicationSignSymptom(entity)
                            }
                            style = kotlinext.js.js { width = "100%" }
                        }
                        IntRange(1, 30).forEach { opt ->
                            option {
                                attrs {
                                    label = "${opt}"
                                    value = "${opt}"
                                }
                                +"${opt}"
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "状态"
                    }
                    if(!editingSyndromeIndicationSignSymptom.id.isNullOrBlank()) {
                        radioGroup {
                            attrs {
                                value = editingSyndromeIndicationSignSymptom.status
                                onChange = { event ->
                                    val symptom = Object.assign(
                                        SyndromeIndicationSignSymptom(),
                                        editingSyndromeIndicationSignSymptom
                                    )
                                    symptom.status = event.target.value
                                    setEditingSyndromeIndicationSignSymptom(symptom)
                                }
                            }
                            SyndromeIndicationSignSymptomStatus.values().forEach { type ->
                                radioButton {
                                    attrs {
                                        value = type
                                    }
                                    +"${type.getLiteral()}"
                                }
                            }
                        }
                    }

                }

                if(!statusMessage.isNullOrBlank()){
                    formItem{
                        span{
                            +"${statusMessage}"
                        }
                    }
                }

                /**
                 *
                `parent_id` varchar(32) CHARACTER SET utf8 COLLATE utf8_general_ci DEFAULT NULL,
                `score` int DEFAULT NULL COMMENT '得分，暂未考虑好如何使用，也许仅针对可见类型',
                 */

            }
        }
    }
}
